import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-excel-file-uploader',
  templateUrl: './excel-file-uploader.component.html',
  styleUrls: ['./excel-file-uploader.component.scss']
})
export class ExcelFileUploaderComponent {
  @Output() fileSelected = new EventEmitter<any>();

  // lets a parent hand this widget an already-picked file (e.g. fetched from a URL) so it renders the same
  // "selected" preview a manual drag/drop or browse would — doesn't re-emit fileSelected, the parent already has it
  @Input() set preSelectedFile(file: File | null) {
    if (file) {
      this.selectedFile = file;
    }
  }

  @ViewChild('fileInput') fileInputRef: ElementRef<HTMLInputElement>;

  isHighlighted = false;
  selectedFile: File | null = null;

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isHighlighted = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isHighlighted = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isHighlighted = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFile(files[0]);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.handleFile(input.files[0]);
    }
  }

  handleFile(file: File) {
    const allowedTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv',
      'application/csv',
    ];

    if (allowedTypes.includes(file.type)) {
      this.selectedFile = file;
      this.fileSelected.emit(file); // 🔥 Emit to parent
    } else {
      this.fileSelected.emit('not-supported');
      // Reset file input so user can select the same file again
      if (this.fileInputRef) {
        this.fileInputRef.nativeElement.value = '';
      }
    }
  }

  clearFile() {
    this.selectedFile = null;
    this.fileSelected.emit(null); // Notify parent of removal
  }
}
